"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const make_traps_1 = require("./make_traps");
const unwatch_1 = require("./unwatch");
const utils_1 = require("./utils");
/* WATCH */
function watch(object, callback) {
    if (utils_1.default.isValueUnproxiable(object))
        return [object, () => object];
    const proxy = new Proxy(object, make_traps_1.default(object, callback)), disposer = () => unwatch_1.default(proxy);
    return [proxy, disposer];
}
/* EXPORT */
exports.default = watch;
